import { categories } from "@/mocks/categories";

export default function CategoryDropdown() {
  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      window.open(url, "_blank", "noopener,nofollow");
    }
  };

  return (
    <section className="py-12 md:py-16 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="max-w-lg mx-auto text-center">
          <h2 className="font-heading text-2xl md:text-3xl font-semibold text-foreground-900 mb-2">
            Browse by Category
          </h2>
          <p className="text-sm text-foreground-600 mb-6">
            Select a category below to explore curated CSSBuy Spreadsheet collections
          </p>
          <div className="relative">
            <select
              onChange={handleChange}
              defaultValue=""
              className="w-full appearance-none bg-background-100 border border-background-300 rounded-lg px-5 py-3.5 text-foreground-900 text-sm cursor-pointer focus:outline-none focus:ring-2 focus:ring-primary-400 focus:border-primary-400 transition-all duration-200 pr-12"
            >
              <option value="" disabled>
                — Choose a category —
              </option>
              {categories.map((cat) => (
                <option key={cat.name} value={cat.url}>
                  {cat.name}
                </option>
              ))}
            </select>
            <div className="absolute right-4 top-1/2 -translate-y-1/2 pointer-events-none">
              <i className="ri-arrow-down-s-line text-foreground-500 text-lg w-5 h-5 flex items-center justify-center"></i>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}